import { GET_USERS_FAILURE, GET_USERS_REQUEST, GET_USERS_SUCCESS, GetUsersActionTypes, GetUsersState } from './types';

const defaultState: GetUsersState = {
  isLoading: false,
  errorMessage: "",
};

export default function getUsers(state = defaultState, action: GetUsersActionTypes): GetUsersState {
  switch (action.type) {
    case GET_USERS_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case GET_USERS_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case GET_USERS_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};
